module.exports = __webpack_public_path__ + "img/icon-smiley-smile.7a6b399.svg";